import { render, staticRenderFns } from "./ClerkCourts.vue?vue&type=template&id=36663a11&scoped=true&"
import script from "./ClerkCourts.vue?vue&type=script&lang=js&"
export * from "./ClerkCourts.vue?vue&type=script&lang=js&"
import style0 from "./ClerkCourts.vue?vue&type=style&index=0&id=36663a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36663a11",
  null
  
)

export default component.exports